import type { AdminMiscCredentialsIndex } from '@/types';
import { CredentialCardView } from './components/CredentialCardView';
import { ExportButton } from './components/ExportButton';

export default function Index({
  title,
  summary,
  empty,
  containers,
  card,
  dateLabel,
  cityLabel,
  sponsorsAsset,
  cardFootMarginTop,
}: AdminMiscCredentialsIndex) {
  const design = { card, dateLabel, cityLabel, sponsorsAsset, cardFootMarginTop };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="w-full">
        <div className="mb-8">
          <h1 className="mb-2 font-bold text-4xl text-gray-900">{title}</h1>
          <p className="text-gray-600">{summary}</p>
          <div className="mt-4">
            <ExportButton />
          </div>
        </div>

        <div className="flex flex-col gap-8">
          {containers.map((container, index) => (
            <div key={container.label} className="flex flex-col gap-4">
              <div className="font-bold text-2xl text-gray-900">
                {container.label}
              </div>
              <div
                data-container-id={index + 1}
                className="flex items-center justify-center p-12"
                style={{
                  width: '2800px',
                  minHeight: '10000px',
                }}
              >
                <div className="grid h-full grid-cols-4 content-center justify-items-center gap-16">
                  {container.cards.map((credential) => (
                    <CredentialCardView
                      key={credential.key}
                      card={credential}
                      design={design}
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {empty && (
          <div className="py-20 text-center">
            <p className="text-gray-600 text-lg">No credentials found</p>
          </div>
        )}
      </div>
    </div>
  );
}
